import { gql } from '@apollo/client';
import COMPONENT_COLORS_AND_SIZES from '../fragments/COMPONENT_COLORS_AND_SIZES';
const SET_SPECIFICATION_SIZE_TO_VARIANT_SIZE_ASSIGNMENT = gql `
  ${COMPONENT_COLORS_AND_SIZES}
  mutation SetSpecificationSizeToVariantSizeAssignment(
    $componentId: ID!
    $modelSpecificationSizeId: ID!
    $productVariantSize: String!
  ) {
    setSpecificationSizeToVariantSizeAssignment(
      componentId: $componentId
      modelSpecificationSizeId: $modelSpecificationSizeId
      productVariantSize: $productVariantSize
    ) {
      component {
        id
        ...ComponentColorsAndSizesFragment
      }
    }
  }
`;
export default SET_SPECIFICATION_SIZE_TO_VARIANT_SIZE_ASSIGNMENT;
